export const SET_WELCOME = 'SET_WELCOME';
export const RESET_NEWLY_AUTHENTICATED = 'RESET_NEWLY_AUTHENTICATED';

export function setWelcome(isWelcome) {
  return {
    type: SET_WELCOME,
    isWelcome
  };
}
// eslint-disable-next-line no-unused-vars
export function resetNewlyAuthenticated(newlyAuthenticated) {
  return {
    type: RESET_NEWLY_AUTHENTICATED
  };
}



// WEBPACK FOOTER //
// ./js/actions/session.js